// extracted by css-extract-rspack-plugin
export default {"menuItem":"u3KVu1gmS8QMeC8w"};